module.exports = __webpack_public_path__ + "assets/7d63156ea1ebfd54e0fd46a42b18e94d.png";